import { createAction } from '@reduxjs/toolkit'
import { ActionTypes_StationsCounters } from './TActions'
import { TStationsCounters } from './TReducer'
import { TStoreTemplate } from 'redux/config/root-types'

const { StoreActions } = ActionTypes_StationsCounters

export const Actions_StationsCounters = {
  saga: {},

  store: {
    showLoader: createAction(StoreActions.IS_LOADER_SHOW),
    hideLoader: createAction(StoreActions.IS_LOADER_HIDE),
    saveStationsCounters: createAction<TStoreTemplate<TStationsCounters>>(StoreActions.SAVE_STATIONS_COUNTERS),
  },
}
